export default "__VITE_ASSET__KaiNiRhh__"